import axios from 'axios';
import store from '../../store';

import { SERVER_API_URL } from '@/constants';

const TIMEOUT = 1000000;
const onRequestSuccess = config => {
  store.commit('increasePendingRequests');
  const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.timeout = TIMEOUT;
  config.url = `${SERVER_API_URL}${config.url}`;
  return config;
};

const onResponse = res => {
  store.commit('decreasePendingRequests');
  return res;
};

const setupAxiosInterceptors = onUnauthenticated => {
  const onResponseError = err => {
    store.commit('decreasePendingRequests');
    const status = err.status || err.response.status;
    if (status === 403 || status === 401) {
      onUnauthenticated();
    }
    return Promise.reject(err);
  };
  if (axios.interceptors) {
    axios.interceptors.request.use(onRequestSuccess);
    axios.interceptors.response.use(onResponse, onResponseError);
  }
};

export { onRequestSuccess, setupAxiosInterceptors };
